import React, { useState, useEffect, useContext} from "react"

import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import {
  Box,
} from '@material-ui/core';
import moment from 'moment';
import 'moment/locale/fr'

import NewCertifChart from "./NewCertifChart"
import CircularGauge from "./CircularGauge"
import SkillResultCard from "./SkillResultCard"

import logoBlanc from "../../images/logoBlanc-pdf.png"
import logoNoir from "../../images/logoNoir-pdf.png"
import downArrowRapportIcon from "../../images/downArrowRapport.svg"

import { textesForCats, textesForFamilies } from "../../utils/rapportTextes.js"

moment.locale("fr");

let pageDimensions = {width : "1250px", height:"1768px"}


const LegendSvg = ({color}) => {
  return (
    <svg width="52" height="60" viewBox="0 0 52 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M51.4648 15.2881V44.7109L25.9844 59.4229L0.503906 44.7109V15.2881L25.9844 0.576172L51.4648 15.2881Z" fill={color} fillOpacity="0.2" stroke={color}/>
    </svg>
  )
}

const TopForPage = ({page, pageTot}) => {
  return (
    <Box sx={{
      display:"flex",
      justifyContent:"space-between",
      position:"relative",
      marginBottom:"22px",
    }}>
      <img src={logoNoir} style={{width:"187px", height:"35px"}}/>
      <Box sx={{textAlign:"right"}}>
        <Box sx={{
          fontSize:"30px"
        }}>
          Rapport The Scan
        </Box>
        <Box sx={{
          fontSize:"16px",
          marginTop:"4px",
        }}>
          Page {page} sur {pageTot}
        </Box>
      </Box>
      <Box sx={{
        position:"absolute",
        bottom:"-22px",
        right:"-75px",
        width:"600px",
        height:"2px",
        background:"#D4D4D4",
      }}/>
    </Box>
  )
}

const CandidatInfos = ({user, result}) => {
  return (
    <>
      <Box sx={{marginTop:"105px", display:"flex", gap:"20px", overflow:"hidden"}}>
        <Box sx={{width:"460px", minWidth:"460px", maxWidth:"460px", overflow:"hidden"}}>
          <Box sx={{fontSize:"22px", opacity:0.75}}>Candidat</Box>
          <Box sx={{fontSize:"46px", whiteSpace:"noWrap", overflow:"hidden", textOverflow:"ellipsis", textTransform:"capitalize"}}>{user?.userName}</Box>
        </Box>
        <Box sx={{overflow:"hidden"}}>
          <Box sx={{fontSize:"22px", opacity:0.75}}>Poste</Box>
          <Box sx={{fontSize:"46px", whiteSpace:"noWrap", overflow:"hidden", textOverflow:"ellipsis", textTransform:"capitalize"}}>{result?.poste}</Box>
        </Box>
      </Box>

      <Box sx={{marginTop:"60px", display:"flex", gap:"20px", overflow:"hidden"}}>
        <Box sx={{width:"200px", minWidth:"200px", maxWidth:"200px", overflow:"hidden"}}>
          <Box sx={{fontSize:"20px", opacity:0.75}}>Durée</Box>
          <Box sx={{fontSize:"32px", whiteSpace:"noWrap", overflow:"hidden", textOverflow:"ellipsis"}}>{result?.timing} mins</Box>
        </Box>
        <Box sx={{width:"240px", minWidth:"240px", maxWidth:"240px", overflow:"hidden"}}>
          <Box sx={{fontSize:"20px", opacity:0.75}}>Date de passation</Box>
          <Box sx={{fontSize:"32px", whiteSpace:"noWrap", overflow:"hidden", textOverflow:"ellipsis"}}>{moment(result?.date).format("DD/MM/YYYY")}</Box>
        </Box>
        <Box sx={{overflow:"hidden"}}>
          <Box sx={{fontSize:"20px", opacity:0.75}}>Référence Scan</Box>
          <Box sx={{fontSize:"32px", whiteSpace:"noWrap", overflow:"hidden", textOverflow:"ellipsis", textTransform:"capitalize"}}>{result?.refScan}</Box>
        </Box>
      </Box>
    </>
  )
}

const SkillItem = ({catKey, score, seuil, isLast, isOK}) => {
  let texte = ""
  let title = catKey

  function strNoAccent(a) {
    return a.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  let find = textesForCats?.find((el) => {
    for (let i=0; i<el?.keys?.length; i++) {
      let actKey = el?.keys[i]
      if ( strNoAccent(actKey?.toLowerCase()?.trim()) === strNoAccent(catKey?.toLowerCase()?.trim()) ) {
        return true
      }
    }
  })

  if (find) {
    title = find?.title
    if (isOK) {
      texte = find?.ok
    } else {
      texte = find?.pasOK
    }
  } else {
    console.log("not find for : ", catKey)
  }
  return (
    <Box sx={{display:"flex", gap:"10px",}}>
      <Box sx={{
        marginLeft:"25px",
        width:"25px",
        height:isLast?"68px":"unset",
        borderLeft:"3px solid black",
        position:"relative"
      }}>
        <Box sx={{position:"absolute", left:"0px", top:"65px", width:"22px", height:"3px", background:"black"}} />
      </Box>
      <Box sx={{
        flex:1
      }}>
        <Box sx={{marginTop:"18px", background:"blue", width:"100%"}}>
          <SkillResultCard
            name={title}
            result={score || 0}
            seuil={seuil || 0}
            seuilColor={isOK?"rgba(83, 215, 105, 1)":"rgba(252, 48, 64, 1)"}
          />
        </Box>
        <Box sx={{width:"100%", display:"flex", gap:"10px", opacity : texte?.length > 0 ? 1 : 0}}>
          <Box sx={{marginLeft:"45px"}}>
            <img src={downArrowRapportIcon} />
          </Box>
          <Box sx={{marginTop:"12px", fontSize:"18px", lineHeight:"140%", color:"rgba(10, 10, 11, 0.7)", height:"76px"}}>
            {texte}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const Rapport = React.forwardRef(({ user, actScan, getDatasForChart }, ref) => {

  let [result, setResult] = useState(null)
  let [skillsPages, setSkillsPages] = useState([])

  useEffect(() => {

    let labelsCategories = ['communication','efficacite','leadership']
    let softSkillsByFamily = actScan?.finalSoftSkills?.sort((a, b) => a?.family?.localeCompare(b?.family));

    let userResult = actScan?.userResults?.find((el) => el.userID === user.userID)
    let resultFin = JSON.parse(userResult?.resultFin)

    softSkillsByFamily?.forEach((skill) => {
      if (resultFin[skill.key]) {
        skill.score = resultFin[skill.key]?.score
      } else {
        skill.score = 0
      }

      if (skill?.score >= skill?.seuil) {
        skill.isOK = true
      }
    })


    let finalScore = 0
    let totalFinalScore = 0
    softSkillsByFamily.forEach((skill) => {
      let score = skill?.score || 0
      let seuil = skill?.seuil || 0
      let calc = 30*(score-seuil)/(100-seuil)

      totalFinalScore += (70 + calc)
    })
    if (softSkillsByFamily?.length > 0) {
      finalScore = totalFinalScore / softSkillsByFamily?.length
    }
    /*if (resultFin?.glbMaster) {
      finalScore = resultFin?.glbMaster?.score
    } else if (resultFin?.master) {
      finalScore = resultFin?.master?.score
    }*/

    setResult({
      timing : actScan?.module?.timing || 0,
      refScan : actScan?.module?.name,
      isValid : userResult?.validationResult || false,
      date : userResult?.resultUpdatedAt,
      finalScore : finalScore,
      poste : actScan?.name,
    })


    let newPages = []

    //on regarde pour chaque catégorie
    labelsCategories?.forEach((cat) => {
      let findTextes = textesForFamilies[cat]
      let skills = softSkillsByFamily.filter((el) => el.family === cat)
      let skillsOK = skills.filter((el) => el.isOK === true).sort((a,b)=>(b.score - a.score))
      let skillsPasOK = skills.filter((el) => el.isOK !== true).sort((a,b)=>(b.score - a.score))
      //on regarde le nombre de OK et de pas OK
      if (skillsOK?.length <= 3 && skillsPasOK?.length <= 3) {
        newPages.push({
          title : findTextes?.title,
          subTitle : findTextes?.subTitle,
          skillsOK : skillsOK,
          skillsPasOK : skillsPasOK,
        })
      } else {
        //une page pour les OK et une page pour les pas OK
        if (skillsOK?.length > 0) {
          newPages.push({
            title : findTextes?.title,
            subTitle : findTextes?.subTitle,
            skillsOK : skillsOK,
          })
        }
        if (skillsPasOK?.length > 0) {
          newPages.push({
            title : findTextes?.title,
            subTitle : findTextes?.subTitle,
            skillsPasOK : skillsPasOK,
          })
        }
      }
    })

    setSkillsPages(newPages)

  }, [actScan])

  const getGlobalValidText = (valid) => {
    let find = textesForCats?.find((el) => el?.keys?.includes("master"))
    if (find) {
      if (valid === true) {
        return find?.ok
      } else {
        return find?.pasOK
      }
     }
    return ""
  }


  return (
    <Box sx={{
      height:"1000px",
      maxHeight:"1000px",
      minHeight:"1000px",
      //overflowX:"auto",
      overflowY:"auto",
      position:"absolute",
      top:"99999px",
      //top:"0px",
      left:0,
      zIndex:9999999,
      fontFamily: "Roboto, sans-serif",
    }}>
      {result &&
        <Box ref={ref} sx={{
          width:pageDimensions?.width,
          maxWidth:pageDimensions?.width,
          minWidth:pageDimensions?.width,
        }}>
          {/* PREMIERE PAGE */}
          <Box sx={{
            width:pageDimensions?.width,
            height:pageDimensions?.height,
            maxWidth:pageDimensions?.width,
            minWidth:pageDimensions?.width,
            maxHeight:pageDimensions?.height,
            minHeight:pageDimensions?.height,
            background:result?.isValid ? "linear-gradient(0deg,rgba(29, 62, 34, 1) 0%, rgba(47, 47, 47, 1) 30%)" : "linear-gradient(0deg,rgba(73, 20, 24, 1) 0%, rgba(47, 47, 47, 1) 30%)",
            padding:"85px",
            color:"white",
          }}>
            <img src={logoBlanc} style={{width:"187px", height:"35px"}}/>
            <Box sx={{marginTop:"190px", fontSize:"102px"}}>
              Rapport recruteur
            </Box>
            <Box sx={{
              marginTop:"57px",
              height:"2px",
              width:"500px",
              background:result?.isValid ? "#53D769" : "#FC3040",
            }}/>
            <CandidatInfos user={user} result={result}/>
          </Box>
          {/* END PREMIERE PAGE */}

          {/* PAGE GRAPH */}
          <Box sx={{
            width:pageDimensions?.width,
            height:pageDimensions?.height,
            maxWidth:pageDimensions?.width,
            minWidth:pageDimensions?.width,
            maxHeight:pageDimensions?.height,
            minHeight:pageDimensions?.height,
            background:"#FAF8F6",
            color:"black",
            padding:"35px 75px",
          }}>
            <TopForPage
              page={2}
              pageTot={skillsPages?.length + 4}
            />

            <Box sx={{
              marginTop:"130px"
            }}>
              <Box sx={{ fontSize:"52px" }}>
                Synthèse de compatibilité avec le poste
              </Box>
              <Box sx={{ marginTop:"20px", fontSize:"20px", color:"rgba(0,0,0,0.7)", lineHeight:"140%" }}>
                Cette section présente le niveau de compatibilité entre le profil comportemental du<br/>candidat et les compétences clés définies pour ce poste.
              </Box>
              <Box sx={{ marginTop:"25px", display:"flex", gap:"30px", }}>
                <Box sx={{display:"flex", gap:"16px", alignItems:"center"}}>
                  <LegendSvg color="#FED030"/>
                  <Box sx={{ fontSize:"18px" }}>
                    Seuil requis
                  </Box>
                </Box>
                <Box sx={{display:"flex", gap:"16px", alignItems:"center"}}>
                  <LegendSvg color="#FF5106"/>
                  <Box sx={{ fontSize:"18px" }}>
                    Innovation & communication
                  </Box>
                </Box>
                <Box sx={{display:"flex", gap:"16px", alignItems:"center"}}>
                  <LegendSvg color="#4F39FF"/>
                  <Box sx={{ fontSize:"18px" }}>
                    Efficacité opérationnelle
                  </Box>
                <Box sx={{display:"flex", gap:"16px", alignItems:"center"}}>
                  <LegendSvg color="#F390FF"/>
                  <Box sx={{ fontSize:"18px" }}>
                    Leadership & collaboration
                  </Box>
                </Box>
                </Box>
              </Box>
              <Box sx={{marginTop:"100px"}}>
                <NewCertifChart
                  datas={getDatasForChart(true)}
                />
              </Box>
            </Box>
          </Box>
          {/* END PAGE GRAPH */}

          {/* PAGE COMPATIBILITE GLOBALE */}
          <Box sx={{
            width:pageDimensions?.width,
            height:pageDimensions?.height,
            maxWidth:pageDimensions?.width,
            minWidth:pageDimensions?.width,
            maxHeight:pageDimensions?.height,
            minHeight:pageDimensions?.height,
            background:"#FAF8F6",
            color:"black",
            padding:"35px 75px",
          }}>
            <TopForPage
              page={3}
              pageTot={skillsPages?.length + 4}
            />

            <Box sx={{
              marginTop:"130px"
            }}>
              <Box sx={{ fontSize:"52px" }}>
                Compatibilité globale au poste
              </Box>

              <Box sx={{display:"flex", marginTop:"75px", gap:"80px"}}>
                <Box sx={{width:"275px"}}>
                  <CircularGauge value={result?.finalScore} size={275} activeColor={result?.isValid ? "#53D769" : "#FC3040"}/>
                </Box>
                <Box>
                  <Box sx={{fontSize:"32px", fontWeight:500, marginBottom:"20px"}}>
                    {result?.isValid ? "Profil aligné avec les compétences requises" : "Profil non-aligné avec les compétences requises"}
                  </Box>
                  <Box sx={{fontSize:"24px", color:"rgba(10, 10, 11, 0.7)", lineHeight: "140%",}}>
                    {getGlobalValidText(result?.isValid)}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          {/* END PAGE COMPATIBILITE GLOBALE */}

          {skillsPages?.map((page, pageIndex) => {
            return (
              <Box key={pageIndex} sx={{
                width:pageDimensions?.width,
                height:pageDimensions?.height,
                maxWidth:pageDimensions?.width,
                minWidth:pageDimensions?.width,
                maxHeight:pageDimensions?.height,
                minHeight:pageDimensions?.height,
                background:"#FAF8F6",
                color:"black",
                padding:"35px 75px",
              }}>
                <TopForPage
                  page={pageIndex+4}
                  pageTot={skillsPages?.length + 4}
                />
                <Box sx={{
                  marginTop:"50px"
                }}>
                  <Box sx={{ fontSize:"42px", fontWeight:500, marginBottom:"5px"}}>
                    {page.title}
                  </Box>
                  <Box sx={{ fontSize:"20px", color:"rgba(10, 10, 11, 0.7)", lineHeight: "140%", whiteSpace:"pre-line" }}>
                    {page.subTitle}
                  </Box>
                  <Box sx={{
                    marginTop:"40px",
                    display:"flex",
                    flexDirection:"column",
                    gap:"40px",
                  }}>
                    {page?.skillsOK?.length > 0 &&
                      <Box>
                        <Box sx={{fontSize:"28px", fontWeight:500}}>Point de compatibilité avec le poste</Box>
                        <Box sx={{marginTop:"15px"}}>
                          {page?.skillsOK?.map((elem, index) => {
                            return (
                              <SkillItem
                                key={index}
                                catKey={elem?.key}
                                score={elem?.score}
                                seuil={elem?.seuil}
                                isLast={index+1 === page?.skillsOK?.length}
                                isOK={true}
                              />
                            )
                          })}
                        </Box>
                      </Box>
                    }
                    {page?.skillsPasOK?.length > 0 &&
                      <Box>
                        <Box sx={{fontSize:"28px", fontWeight:500}}>Point d’incompatibilité avec le poste</Box>
                        <Box sx={{marginTop:"15px"}}>
                        {page?.skillsPasOK?.map((elem, index) => {
                          return (
                            <SkillItem
                              key={index}
                              catKey={elem?.key}
                              score={elem?.score}
                              seuil={elem?.seuil}
                              isLast={index+1 === page?.skillsPasOK?.length}
                              isOK={false}
                            />
                          )
                        })}

                        </Box>
                      </Box>
                    }
                  </Box>
                </Box>
              </Box>
            )
          })}

          {/* LAST PAGE */}
          <Box sx={{
            width:pageDimensions?.width,
            height:pageDimensions?.height,
            maxWidth:pageDimensions?.width,
            minWidth:pageDimensions?.width,
            maxHeight:pageDimensions?.height,
            minHeight:pageDimensions?.height,
            background:result?.isValid ? "linear-gradient(0deg,rgba(29, 62, 34, 1) 0%, rgba(47, 47, 47, 1) 30%)" : "linear-gradient(0deg,rgba(73, 20, 24, 1) 0%, rgba(47, 47, 47, 1) 30%)",
            padding:"85px",
            color:"white",
            position:"relative"
          }}>
            {result?.isValid ? (
              <Box sx={{color:"#53D769", marginTop:"190px", fontSize:"73px"}}>
                Compatible
              </Box>
            ) : (
              <Box sx={{color:"#FC3040", marginTop:"190px", fontSize:"73px"}}>
                Incompatible
              </Box>
            )}
            <CandidatInfos
              user={user}
              result={result}
            />
            <Box sx={{fontSize:"26px", marginTop:"60px", marginBottom:"5px"}}>Méthodologie</Box>
            <Box sx={{fontSize:"20px", lineHeight:"140%", opacity:0.7}}>
              Le Scan Rising Up évalue le niveau de compatibilité entre le profil comportemental d’un candidat et les compétences définies comme essentielles pour un poste. L’évaluation repose sur l’analyse de plusieurs compétences comportementales mesurées à partir d’un test standardisé. Les résultats obtenus sont ensuite comparés aux seuils définis pour le poste afin d’estimer le niveau d’adéquation avec les exigences attendues dans ce contexte professionnel.<br/>
              <br/>Les résultats présentés dans ce rapport constituent un indicateur d’aide à la décision dans le cadre d’un processus de recrutement. Ils doivent être interprétés en complément d’autres éléments d’évaluation du candidat, tels que l’expérience professionnelle, les compétences techniques ou les entretiens réalisés au cours du processus de sélection. Comme toute évaluation comportementale, les résultats reflètent des tendances observées au moment du test et peuvent évoluer selon le contexte, l’expérience ou le développement professionnel du candidat.
            </Box>
            <Box sx={{
               position:"absolute", bottom:"60px", left:"0", width:"100%", display:"flex", justifyContent:"center",
            }}>
              <img src={logoBlanc} style={{width:"187px", height:"35px"}}/>
            </Box>
          </Box>
          {/* END LAST PAGE */}



        </Box>
      }
    </Box>
  )
});

export default Rapport;
